'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var _vendorMerge = require('../vendor/merge');

var _vendorMerge2 = _interopRequireDefault(_vendorMerge);

var _style = require('./style');

var _ = require('./');

var _utils = require('./utils');

var DialogStyles = _reactStyle2['default'].create({
  normalStyle: {
    backgroundColor: _style.Colors.grey.P50,
    boxSizing: 'border-box',
    lineHeight: '24px',
    opacity: '0',
    padding: 24,
    left: '50%',
    top: '50%',
    visibility: 'hidden',
    position: 'fixed',
    transform: 'translate(0,0) scale(1, 1)',
    transformOrigin: '0 0',
    zIndex: '3',
    willChange: 'transform, opacity, left, top'
  },

  titleStyle: {
    paddingBottom: 10
  },

  expandStyle: {
    visibility: 'visible',
    opacity: '1'
  },

  childrenStyle: {
    // to re-enable text selection
    position: 'relative'
  },

  slideDownStyle: {
    opacity: '0',
    transform: 'translate(0, 100%) scale(.5,.5)',
    transition: 'transform .56s cubic-bezier(.4, 0, .2, 1),' + 'opacity .56s cubic-bezier(.4, 0, .2, 1), ' + 'visibility 0s linear .57s',
    visibility: 'hidden'
  }
});

// warning: this code is fugly - did several attempts of getting
// the effects right, which was a challenge

var _default = (function (_React$Component) {
  var _class = function _default(props) {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this, props);
    this.state = {
      expand: false
    };
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_utils.transitionEnd) {
        return;
      }

      _react2['default'].findDOMNode(this.refs.dialog).addEventListener(_utils.transitionEnd, this.onTransitionEnd.bind(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!_utils.transitionEnd) {
        return;
      }

      _react2['default'].findDOMNode(this.refs.dialog).removeEventListener(_utils.transitionEnd, this.onTransitionEnd.bind(this));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this = this;

      setTimeout(function () {
        if (_this.reset) {
          _this.reset = false;
          return;
        }

        if (!_this.state.expand && _this.props.show) {
          _this.setState({ expand: true });
        }
      }, 10);
    }
  }, {
    key: 'onTransitionEnd',
    value: function onTransitionEnd(e) {
      if (e.propertyName === 'visibility') {
        this.wasVisible = false;
        this.reset = true;
        this.setState({ expand: false });
      }
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle(title, styles) {
      if (!title) {
        return null;
      }

      return _react2['default'].createElement(
        'div',
        { styles: styles },
        title
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var node = undefined,
          dimensions = undefined;
      var styles = DialogStyles;
      var shadow = 3;

      var _props = this.props;
      var children = _props.children;
      var show = _props.show;
      var title = _props.title;
      var triggerElement = _props.triggerElement;
      var width = _props.width;
      var expand = this.state.expand;

      var normalStyles = [_style.Typography.body2, styles.normalStyle];

      if (triggerElement && (node = _react2['default'].findDOMNode(triggerElement))) {
        var domNode = _react2['default'].findDOMNode(this);

        if (!this.originalDimensions) {
          var nodeWidth = domNode.getBoundingClientRect().width;

          var scaleX = 1 / (domNode.offsetWidth / node.offsetWidth);
          var scaleY = 1 / (domNode.offsetHeight / node.offsetHeight);

          var x = -domNode.getBoundingClientRect().left + nodeWidth / 2 + node.getBoundingClientRect().left;

          var y = -domNode.getBoundingClientRect().top + domNode.offsetHeight / 2 + node.getBoundingClientRect().top;

          dimensions = this.originalDimensions = {
            height: domNode.offsetHeight,
            marginLeft: -(nodeWidth / 2),
            marginTop: -(domNode.offsetHeight / 2),
            width: nodeWidth,
            transform: 'translate(' + x + 'px, ' + y + 'px) ' + 'scale(' + scaleX + ', ' + scaleY + ')'
          };
        }

        if (expand) {
          normalStyles.push(styles.expandStyle);
          dimensions = (0, _vendorMerge2['default'])(this.originalDimensions, {
            transition: 'visibility 0s ' + 'linear 0s, ' + 'opacity .4s ' + 'cubic-bezier(.4, 0, .2, 1) 0.02s, ' + 'transform .4s cubic-bezier(.4, 0, .2, 1) 0.02s'
          });
          delete dimensions.transform;
        } else {
          dimensions = this.originalDimensions;
        }
      }

      if (show) {
        this.wasVisible = true;
      } else if (this.wasVisible) {
        delete dimensions.transition;
        normalStyles.push(styles.slideDownStyle);
      }

      if (dimensions) {
        normalStyles.push(dimensions);
      }

      if (width) {
        normalStyles.push({ width: width });
      }

      return _react2['default'].createElement(
        'div',
        {
          ref: 'dialog',
          styles: normalStyles },
        _react2['default'].createElement(_.Shadow, { size: shadow }),
        this.renderTitle(title, [_style.Typography.title, styles.titleStyle]),
        _react2['default'].createElement(
          'div',
          { styles: styles.childrenStyle },
          children
        )
      );
    }
  }], [{
    key: 'displayName',
    value: 'Dialog',
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      children: _react.PropTypes.node,
      show: _react.PropTypes.bool,
      title: _react.PropTypes.string,
      triggerElement: _react.PropTypes.node,
      width: _react.PropTypes.number
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/Dialog.js
 ** module id = 193
 ** module chunks = 0
 **/